<script>
export default {
    name: 'IlluManagementEnseignants',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-management-enseignants"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M32 18.5c-2.1 0-4.04.681-5.613 1.835a9.52 9.52 0 00-3.403 4.666 9.521 9.521 0 003.403 4.665A9.457 9.457 0 0032 31.5c2.1 0 4.04-.681 5.613-1.835A9.523 9.523 0 0041.017 25a9.521 9.521 0 00-3.404-4.665A9.457 9.457 0 0032 18.5zm0-10c-.966 0-1.841.392-2.475 1.025A3.489 3.489 0 0028.5 12c0 .966.392 1.841 1.025 2.475A3.489 3.489 0 0032 15.5c.966 0 1.841-.392 2.475-1.025A3.489 3.489 0 0035.5 12c0-.966-.392-1.841-1.025-2.475A3.489 3.489 0 0032 8.5zM17.542 42.5c-2.1 0-4.04.681-5.613 1.835a9.52 9.52 0 00-3.404 4.666 9.521 9.521 0 003.404 4.665 9.457 9.457 0 005.613 1.834c2.1 0 4.04-.681 5.613-1.835A9.523 9.523 0 0026.559 49a9.521 9.521 0 00-3.404-4.665 9.457 9.457 0 00-5.613-1.835zm0-10c-.967 0-1.842.392-2.475 1.025A3.489 3.489 0 0014.042 36c0 .966.392 1.841 1.025 2.475a3.489 3.489 0 002.475 1.025c.966 0 1.841-.392 2.475-1.025A3.489 3.489 0 0021.042 36c0-.966-.392-1.841-1.025-2.475a3.489 3.489 0 00-2.475-1.025zM46.542 42.5c-2.1 0-4.04.681-5.613 1.835a9.52 9.52 0 00-3.404 4.666 9.521 9.521 0 003.404 4.665 9.457 9.457 0 005.613 1.834c2.1 0 4.04-.681 5.613-1.835A9.523 9.523 0 0055.559 49a9.521 9.521 0 00-3.404-4.665 9.457 9.457 0 00-5.613-1.835zm0-10c-.967 0-1.842.392-2.475 1.025A3.489 3.489 0 0043.042 36c0 .966.392 1.841 1.025 2.475a3.489 3.489 0 002.475 1.025c.966 0 1.841-.392 2.475-1.025A3.489 3.489 0 0050.042 36c0-.966-.392-1.841-1.025-2.475a3.489 3.489 0 00-2.475-1.025z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <path
                :fill="primaryColor"
                class="primary-color"
                d="M32.982 33v5.666L38 43.561 36.516 45 32 40.591 27.484 45 26 43.561l4.883-4.766V33z"
            />
        </g>
    </svg>
</template>
